import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import messages from './messages';

import LoginModal from '../LoginModal';
import SignupModal from '../SignupModal';
import LinkButton from '../common/LinkButton';
import styles from './AccountLoginModalLauncher.module.scss';

import { setShowLoginModal, setShowSignupModal } from '../../slices/accounts';

const AccountLoginModalLauncher = ({
  linkBlockHeading,
  setLoggedInCustomerId,
  mergeCart,
  redirectToAccountDashboard,
  hideCreateAccount,
}) => {
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();

  const showShopPayEmailCapture = window?.purTogglesEnabled(
    'shop_pay_email_field',
  );
  const showLoginModal = useSelector((state) => state.accounts.showLoginModal);

  const showSignupModal = useSelector(
    (state) => state.accounts.showSignupModal,
  );

  const handleOpenLoginModal = () => {
    dispatch(setShowLoginModal({ showLoginModal: true }));
    dispatch(setShowSignupModal({ showSignupModal: false }));
  };

  return (
    <>
      {linkBlockHeading && (
        <div
          className={classnames(styles['title-container'], {
            [styles['title-container-shop-pay']]: showShopPayEmailCapture,
          })}
        >
          {linkBlockHeading}
          <div className={styles['signin-prompt-text']}>
            <LinkButton
              id="resendButton"
              onClick={handleOpenLoginModal}
              linkText={formatMessage(messages.linkText)}
            />
            {!showShopPayEmailCapture && (
              <span className={styles['signin-prompt-sub-text']}>
                {formatMessage(messages.linkSubText)}
              </span>
            )}
          </div>
        </div>
      )}
      {showLoginModal && (
        <LoginModal
          setLoggedInCustomerId={setLoggedInCustomerId}
          mergeCart={mergeCart}
          redirectToAccountDashboard={redirectToAccountDashboard}
          hideCreateAccount={hideCreateAccount}
        />
      )}
      {showSignupModal && <SignupModal />}
    </>
  );
};

AccountLoginModalLauncher.propTypes = {
  linkBlockHeading: PropTypes.string,
  setLoggedInCustomerId: PropTypes.func.isRequired,
  mergeCart: PropTypes.bool,
  redirectToAccountDashboard: PropTypes.bool,
  hideCreateAccount: PropTypes.bool,
};

AccountLoginModalLauncher.defaultProps = {
  linkBlockHeading: null,
  mergeCart: false,
  redirectToAccountDashboard: false,
  hideCreateAccount: true,
};

export default AccountLoginModalLauncher;
